import React from 'react'
import { useTranslation } from 'react-i18next'

import PopoverColorPicker from '../../../../../components/form/PopoverColorPicker'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'
import { useChecklistFormActions } from '../../_form/ChecklistFormHandler'
import CheckboxInput from '../../../../../components/form/CheckboxInput'
import { useChecklistForm } from '../../_form/ChecklistFormHandler'
import FormItem from '../../../../../components/form/FormItem'

const CalendarViewBgColorSection = () => {
  const { t } = useTranslation('editChecklist')
  const form = useChecklistForm()
  const { handleChange } = useChecklistFormActions()

  const commonProps = { handleChange, form, t }

  const handleChangeCalendarViewBgColor = value => {
    handleChange('configuration', {
      ...form.configuration,
      calendarView: { ...form.configuration?.calendarView, active: value }
    })

    if (!value) {
      delete form.configuration?.calendarView
      handleChange('configuration', { ...form.configuration })
    }
  }

  return (
    <>
      <CheckboxInput
        label={t('fieldsStep.calendarViewActive')}
        value={form?.configuration?.calendarView?.active}
        onChange={handleChangeCalendarViewBgColor}
      />
      {form?.configuration?.calendarView?.active && (
        <>
          <Separator weight={4} />
          <FormItem label={t('fieldsStep.calendarViewBgColor')} field="calendarViewBgColor" {...commonProps}>
            <PopoverColorPicker
              value={form.configuration?.calendarView?.backgroundColor}
              onChange={value =>
                handleChange('configuration', {
                  ...form.configuration,
                  calendarView: { ...form.configuration?.calendarView, backgroundColor: value }
                })
              }
            />
          </FormItem>
        </>
      )}
    </>
  )
}

export default CalendarViewBgColorSection
